import { render, staticRenderFns } from "./StudentVitalsComponent.vue?vue&type=template&id=752480ac&"
import script from "./StudentVitalsComponent.vue?vue&type=script&lang=ts&"
export * from "./StudentVitalsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752480ac')) {
      api.createRecord('752480ac', component.options)
    } else {
      api.reload('752480ac', component.options)
    }
    module.hot.accept("./StudentVitalsComponent.vue?vue&type=template&id=752480ac&", function () {
      api.rerender('752480ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/StudentVitalsComponent.vue"
export default component.exports